"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dimensions = void 0;
var Dimensions;
(function (Dimensions) {
    Dimensions["d0"] = "0rem";
    Dimensions["d1"] = ".0625rem";
    Dimensions["d2"] = ".125rem";
    Dimensions["d4"] = ".25rem";
    Dimensions["d6"] = ".375rem";
    Dimensions["d8"] = ".5rem";
    Dimensions["d9"] = ".5625rem";
    Dimensions["d10"] = ".625rem";
    Dimensions["d11"] = ".6875rem";
    Dimensions["d12"] = ".75rem";
    Dimensions["d13"] = ".8375rem";
    Dimensions["d14"] = ".875rem";
    Dimensions["d15"] = ".9375rem";
    Dimensions["d16"] = "1rem";
    Dimensions["d18"] = "1.125rem";
    Dimensions["d20"] = "1.25rem";
    Dimensions["d22"] = "1.375rem";
    Dimensions["d24"] = "1.5rem";
    Dimensions["d26"] = "1.625rem";
    Dimensions["d28"] = "1.75rem";
    Dimensions["d30"] = "1.875rem";
    Dimensions["d32"] = "2rem";
    Dimensions["d36"] = "2.25rem";
    Dimensions["d38"] = "2.375rem";
    Dimensions["d40"] = "2.5rem";
    Dimensions["d44"] = "2.75rem";
    Dimensions["d48"] = "3rem";
    Dimensions["d52"] = "3.25rem";
    Dimensions["d54"] = "3.375rem";
    Dimensions["d56"] = "3.5rem";
    Dimensions["d60"] = "3.75rem";
    Dimensions["d64"] = "4rem";
    Dimensions["d72"] = "4.5rem";
    Dimensions["d80"] = "5rem";
    Dimensions["d92"] = "5.75rem";
    Dimensions["d96"] = "6rem";
    Dimensions["d104"] = "6.5rem";
    Dimensions["d112"] = "7rem";
    Dimensions["d120"] = "7.5rem";
    Dimensions["d128"] = "8rem";
    Dimensions["d152"] = "9.5rem";
    Dimensions["d160"] = "10rem";
    Dimensions["d176"] = "11rem";
    Dimensions["d192"] = "12rem";
    Dimensions["d208"] = "13rem";
    Dimensions["d224"] = "14rem";
})(Dimensions || (exports.Dimensions = Dimensions = {}));
//# sourceMappingURL=Dimensions.js.map